import { selectUserCollections } from '../../collections';
import { selectAppState } from '../../appState';

import type { MapStateToProps } from 'types/redux';

import type { Schema } from '@wix/wix-data-schema-types';

export interface UserCollectionsListStateProps {
  collections: Schema[];
  availableToAddPreset: boolean;
}

export const mapStateToProps: MapStateToProps<
  UserCollectionsListStateProps
> = ({ state }) => ({
  collections: selectUserCollections(state),
  availableToAddPreset: selectAppState(state).canAddPreset,
});
